
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserIdleService } from 'angular-user-idle';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-dcn-esign-home',
    templateUrl: './dcn-esign-home.component.html',
    styleUrls: ['./dcn-esign-home.component.scss'],
    standalone: false
})
export class DcnEsignHomeComponent implements OnInit {
  title = 'Loblaw';
  user: UsersDataResponse = null
  userData: UserData = null;
  loginForm: UntypedFormGroup;
  loading = false;
  switchLang(lang: string) {
    this.translate.use(lang);
  }
  constructor(private userservice: UserService,protected authService: SsoSecurityService,public translate: TranslateService,private router:Router,
    private formBuilder: UntypedFormBuilder,private userIdle: UserIdleService,private graphservice:GraphService,
    @Inject(DOCUMENT) private document: Document){
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en'); 
    this.switchLang("en") 
  }
  ngOnInit(): void {
    this.userservice.resetUnauthorized();
 //   this.authService.completeAuthentication().then(result=>{
 this.getUserInfo();
 

   //SSS })
 
  }

  getUserInfo() {

    this.graphservice.getProfile().then(result=>{
      
    this.userservice.getLoginUserData().subscribe(data => {
      this.user = new UsersDataResponse()
      this.user = data;
      this.user.userData.nctmAccess=false;
      this.userservice.setCurrentUser(this.user);
      this.userservice.setLogin();
      this.userData = data.userData;
      this.switchLang(this.userData.language.toLowerCase());
      this.getNCTMUserAccess(this.user.userData.upn);
     if ((this.userData.roleId === 4 || this.userData.roleId === 5) && !this.verifyEsa()) {
        this.router.navigate(["/esa"]);
      }else{
      this.router.navigate(["/dcn-esign"]);
      }
    
    },(error: HttpErrorResponse)=>{
      if(error &&(error.status===401 ||error.status===404) ){
        this.router.navigate(["/unauthorized"])
      }

   });
  })
  
  }

  getNCTMUserAccess(upn:string) {
    
    this.userservice.getNCTMUserAccess(upn).subscribe(data=>{
    this.user.userData.nctmAccess=data;
    this.userservice.setCurrentUser(this.user);
   },(error=>{
    this.user.userData.nctmAccess=false;
    this.userservice.setCurrentUser(this.user);
   }));
  
   }

  getUserUPNInfo() {
    this.userservice.getUserDataByUPN(this.loginForm.controls.username.value).subscribe(data => {
      this.user = new UsersDataResponse()
      this.user = data;
      this.userservice.setCurrentUser(this.user);
      this.userData = data.userData
      this.switchLang(this.userData.language);
      if ((this.userData.roleId === 4 || this.userData.roleId === 5) && !this.verifyEsa()) {
        this.router.navigate(["/esa"]);
      }else{
      this.router.navigate(["/dcn-esign"]);
      }
    },(error: HttpErrorResponse)=>{
      if(error &&(error.status===401 ||error.status===404) ){
        this.router.navigate(["/unauthorized"])
      }
    });
  }

  verifyEsa() {
    let valid = true;
    this.user.stores.forEach(element => {
      if (element.electronicSignatureAttestation===null && valid===true) {
        valid = false;
        return valid;
      }
    });

    return valid
  }

  stop() {
    this.userIdle.stopTimer();
  }
 
  stopWatching() {
    this.userIdle.stopWatching();
  }
 
  startWatching() {
    this.userIdle.startWatching();
  }
 
  restart() {
    this.userIdle.resetTimer();
  }
  logout(){
    this.userservice.updateLogoutStatus(this.user.userData.sequenceNumber).subscribe(data=>{
      window.location.href = environment.logouturl;
      // this.document.location.href ="https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout"
 
 //   this.document.location.href = "https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/logout";

    })
}

}
